import { render, staticRenderFns } from "./LungSoundAssessedCheck.vue?vue&type=template&id=677d643e&scoped=true&"
import script from "./LungSoundAssessedCheck.vue?vue&type=script&lang=js&"
export * from "./LungSoundAssessedCheck.vue?vue&type=script&lang=js&"
import style0 from "./LungSoundAssessedCheck.vue?vue&type=style&index=0&id=677d643e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d643e",
  null
  
)

export default component.exports